import React from 'react';
import * as _ from 'lodash';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import FieldTreesApi from '../../../services/fieldTrees/FieldTreesApi';
import FieldTreesService from '../../../services/fieldTrees/FieldTreesService';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import {
  DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT,
  REQUEST_PARAMS
} from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import {
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../../CommonFormComponents';

/**
 * @description 入退場実績追加の作業員一覧所属会社プルダウンで使用
 */
export class FieldTreeCompanyDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      loaded: false, // ページング用ロードフラグ
      opened: false, // 開閉フラグ
      checked: {}, // ラジオボタンチェック用現場情報
      selected: {}, // 選択現場情報
      options: [], // 取得現場情報
      optionData: {}, // 施工体制情報
      offset: 0, // 検索オフセット
      // 検索条件現場名
      condition: {
        name: '',
      },
      isLoading: true, // ロード中フラグ
    };

    this.id = _.uniqueId(); // ユニークID生成
    this.targetId = `infinityscroll-target-field-tree-id-${this.id}`; // スクロールロード用ID
    this.search = this.search.bind(this); // 検索
    this.handleOpen = this.handleOpen.bind(this); // 開閉イベント
    this.setCondition = this.setCondition.bind(this); // 検索条件をセット
    this.handleSelectedRow = this.handleSelectedRow.bind(this); // 選択肢クリック
    this.clearSelectedRow = this.clearSelectedRow.bind(this); // 選択を解除する // 不要？
    this.selectBranch = this.selectBranch.bind(this); // 項目選択
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );

    this.getCompanies = this.getCompanies.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    this.getCompanies(() => {});
  }

  componentDidUpdate(prevProps) {
    if (this.state.opened) {
      // コンポーネントが可視状態の場合、clickイベントをセット
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // コンポーネントが不可視状態の場合、clickイベントを削除
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    // 検索条件クリアボタンの反映
    if (this.props.value !== prevProps.value) {
      const checked = _.isEmpty(this.props.value)
        ? {}
        : _.find(this.state.options, option => {
            return _.isEqual(option.field_tree_ids, this.props.value);
          });
      this.setState({ checked });
    }

    // 「検索条件クリア」ボタンを押すと所属会社検索欄に入力した文字をクリア
    if (this.props.searchBoxClearFlag !== prevProps.searchBoxClearFlag) {
      this.setState(
        {
          condition: {
            name: '',
          },
        },
        () => this.search()
      );
    }
  }

  /**
   * @description クリックした場所を判定
   */
  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
  };

  /**
   * @description ドロップダウンの開閉状態を設定
   */
  handleOpen = () => {
    this.setState({ opened: !this.state.opened });
  };

  /**
   * @description 検索する現場名を設定
   * @param {string} fieldName 現場名
   */
  setCondition = fieldName => {
    const condition = _.cloneDeep(this.state.condition);
    if (condition.name !== fieldName) {
      condition.name = fieldName;
      this.setState(
        {
          condition: {
            name: fieldName,
          },
          options: [],
          optionData: {},
          offset: 0,
        },
        () => {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => {
            this.search();
          }, DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT);
        }
      );
    }
  };

  /**
   * @description 項目を検索
   */
  search = () => {
    const options = [];
    const loaded = false;
    const offset = 0;

    this.getCompanies(() => {}, { options, loaded, offset });
    this.setState({ options, loaded, isLoading: true, offset: options.length });
  };

  /**
   * @description ラジオボタンチェック
   * @param {object} option 項目情報
   */
  handleSelectedRow = (id, selected) => {
    let checked = {};
    if (selected) {
      checked = _.find(this.state.options, option => {
        return _.isEqual(option.field_tree_ids, id);
      });
    }
    this.setState({ checked, opened: false, selected: checked }, () => {
      this.props.onSelect(checked.field_tree_ids);
    });
  };

  clearSelectedRow = () => {
    this.setState({ checked: {}, selected: {}, opened: false }, () => {
      this.props.onSelect([]);
    });
  };

  /**
   * @description 項目選択
   * @param {object} checked 項目情報
   */
  selectBranch = checked => {
    this.props.set('field_id', checked.id);
    this.setState({ selected: checked, opened: false });
  };

  /**
   * @description 所属会社情報取得
   * @param {*} notify
   * @param {object} init 再読み込み設定
   *                      検索現場名を設定時に使用
   */
  getCompanies = (notify, init = {}) => {
    const loaded = _.isEmpty(init) ? this.state.loaded : init.loaded;
    let options = _.isEmpty(init) ? [...this.state.options] : init.options;

    if (loaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }

    let params = {
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.isEmpty(init) ? this.state.offset : init.offset,
      name: this.state.condition.name,
    };

    FieldTreesApi.fetchFieldTreeCompanyBranchList(
      this.state.fieldId,
      FieldTreesService.createSearchFieldTreeCompanyBranchList(params)
    ).then(response => {
      if (response.result) {
        const responseData = response.data.entities.field_trees;
        if (_.isEmpty(responseData)) {
          this.setState({ loaded: true });
        } else {
          // 会社別施工体制情報をstateから取得
          let optionData = this.state.optionData;
          let tempOptions = [];
          let offset = 0;
          _.each(responseData, data => {
            // options.push(branch);
            // stateからoffset + 追加で検索した件数を足す。
            offset = this.state.offset + responseData.length;
            if (optionData[data.company_id] === undefined) {
              optionData[data.company_id] = {};
              optionData[data.company_id].name = data.company_name;
              optionData[data.company_id].field_tree_ids = [data.field_tree_id];
            } else {
              optionData[data.company_id].field_tree_ids.push(
                data.field_tree_id
              );
            }
          });
          _.each(optionData, val => {
            tempOptions.push({
              name: String(val.name),
              field_tree_ids: val.field_tree_ids,
            });
          });
          options = tempOptions;
          this.setState({
            options,
            offset,
            loaded: false,
          });
        }
        this.setState({ isLoading: false });
        notify();
      }
    });
  };

  getDisplayName = () => {
    if (!_.isNil(this.props.value) && this.props.value.length > 0) {
      if (!_.isEmpty(this.state.selected)) {
        return this.state.selected.name;
      }
    }
    return '所属会社を選択';
  };

  render() {
    const { checked, options, opened, optionData } = this.state;

    return (
      <div className='form-dropdown dropdown-multi-select' ref={this.parent}>
        <div className='dropdown-multi-select__header'>
          <div
            id='form-dropdown-btn'
            className='dropdown-select'
            onClick={() => this.handleOpen()}
          >
            <span className='dropdown-select__txt'>
              {this.getDisplayName()}
            </span>
          </div>
        </div>
        {opened && (
          <div
            id='form-dropdown-list'
            className='dropdown dropdown--dropdown-list show'
          >
            <div className='dropdown__item dropdown__item--hidden'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className=''
                  placeholder={messageUtility.getMessage('I-000-090')}
                  defaultValue={this.state.condition.name}
                  onChange={e => this.setCondition(e.target.value)}
                />
              </div>
              <div className='dropdown-single-select__item'>
                <FormDropdownClearButton onClick={this.clearSelectedRow} />
              </div>
              <div className='dropdown-single-select__item'>
                <div
                  className='dropdown-single-select__scroll'
                  id={this.targetId}
                >
                  <ul className='single-select'>
                    {_.map(options, (option, index) => (
                      <FormDropdownRadio
                        key={index}
                        option={option}
                        checked={_.isEqual(
                          checked.field_tree_ids,
                          option.field_tree_ids
                        )}
                        targetId={this.id}
                        handleSelectedRow={this.handleSelectedRow}
                        forId='single-field-branch-id'
                        column='field_tree_ids'
                      >
                        {option.name}
                      </FormDropdownRadio>
                    ))}
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(optionData)}
                      isLoading={this.state.isLoading}
                      callback={this.getCompanies}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldTreeCompanyDropdown.jsx